
<div class="container-fluid pt-3">
	<ul class="nav nav-tabs">
		<li class="nav-item pe-1">
			<a class="nav-link" jhiTranslate="observation-details.observations">Observations</a>
		</li>
	</ul>
	<div class="tab-content">
		<div class="tab-pane container-fluid active">
			<div class="mb-3 row pt-4 ps-4">
				<label for="dropdownvariable" class="col-sm-3 col-form-label fw-bold" jhiTranslate="observation-details.variable">Variable</label>
				<div class="col-sm-9">
					<select class="form-select" id="selectVariable" name="selectVariable"
							[(ngModel)]="selectedVariable" (ngModelChange)="loadAll()" #selectVariable="ngModel">
						<option value="0" jhiTranslate="global.please.choose">Please Choose</option>
						<option *ngFor="let studyVar of studyVariables" [value]="studyVar.termId">{{studyVar.name}}</option>
					</select>
				</div>
			</div>
			<div class="table-responsive p-3" *ngIf="phenotypeAudits">
				<table class="table table-striped table-bordered table-curved table-fixed" *ngIf="phenotypeAudits.length else nodata">
					<thead>
					<tr>
						<th scope="col" jhiTranslate="observation-details.columns.value" class="fixed-collapse-horizontal-100">Created Date</th>
						<th scope="col" jhiTranslate="observation-details.columns.draft-value">Draft Value</th>
						<th scope="col" class="fixed-collapse-horizontal-100">
							<span jhiTranslate="observation-details.columns.timestamp">Timestamp</span>
							<span class="fa fa-sort fa-sort-down"></span>
						</th>
						<th scope="col" jhiTranslate="observation-details.columns.user">User</th>
						<th scope="col" jhiTranslate="observation-details.columns.event">Event</th>
					</tr>
					</thead>
					<tbody>
					<tr *ngFor="let change of phenotypeAudits">
						<td [ngClass]="{ 'diff-new': change.valueChanged }">
							<span *ngIf="change.value">{{change.value}}</span>
							<span *ngIf="!change.value"> - </span>
						</td>
						<td [ngClass]="{ 'diff-new': change.draftValueChanged }">
							<span *ngIf="change.draftValue">{{change.draftValue}}</span>
							<span *ngIf="!change.draftValue"> - </span>
						</td>
						<td>{{formatDate(change.updatedDate)}}</td>
						<td>{{change.updatedBy}}</td>
						<td>{{change.revisionType}}</td>
					</tr>
					</tbody>
				</table>
				<ng-template #nodata>
					<table class="table table-striped table-bordered table-curved">
						<thead>
						<tr>
							<th></th>
						</tr>
						</thead>
						<tbody>
						<tr>
							<td jhiTranslate="no.data"></td>
						</tr>
						</tbody>
					</table>
				</ng-template>
				<div *ngIf="phenotypeAudits && phenotypeAudits.length">
					<div class="row">
						<div class="col">
							<div class="pagination-container">
								<div class="pagination-box pagination-box-left">
									<div>
										<jhi-item-count [page]="page" [total]="queryCount" [itemsPerPage]="itemsPerPage"></jhi-item-count>
									</div>
								</div>
								<div class="pagination-box">
									<ngb-pagination [collectionSize]="totalItems" [(page)]="page" [pageSize]="itemsPerPage" [disabled]="isLoading"
													[maxSize]="5" [rotate]="true" [boundaryLinks]="true" (pageChange)="loadPage(page)"></ngb-pagination>
								</div>
								<div class="pagination-box pagination-box-right">
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
